import React from 'react';

import { TranslationKeys } from 'app/translations';

import type { EmployeeCalculationsOwnContribution } from 'app/hooks';
import type { CalculationsCardProps } from '../CalculationsCard';
import { CalculationsCard } from '../CalculationsCard';

type EmployeePensionOwnContributionDetailsPanelProps = {
  loading?: boolean;
  data: EmployeeCalculationsOwnContribution | undefined;
};

export const EmployeePensionOwnContributionDetailsPanel = ({
  loading = false,
  data,
}: EmployeePensionOwnContributionDetailsPanelProps) => {
  const cardFields = React.useMemo<CalculationsCardProps['fields']>(() => {
    if (data && 'message' in data) {
      return [];
    }

    return [
      {
        labelId: TranslationKeys.employees_pension_premiumPerYearPensionBase,
        formulaId: TranslationKeys.employees_pension_calcFormula_ownContribution_premiumPerYear,
        value: {
          value: data?.premiumPerYear,
          type: 'currency',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_premiumPerMonthPensionBase,
        formulaId: TranslationKeys.employees_pension_calcFormula_ownContribution_premiumPerMonth,
        value: {
          value: data?.premiumPerMonth,
          type: 'currency',
        },
      },
    ];
  }, [data]);

  return (
    <CalculationsCard
      isLoading={loading}
      titleId={TranslationKeys.employees_detail_ownContribution}
      fields={cardFields}
      error={data?.message}
    />
  );
};
